import React from 'react';
import {Table} from "reactstrap";

class FollowupSoldTable extends React.Component {
    constructor(props) {
        super(props);
        this.formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'AUD',
        });
    }

    getData = () => {
        //get a list of all the appointments that are in terms agreed
        var repData = [];
        var salesIDS = [];
        this.props.salesData.forEach(s => {
            if (salesIDS.indexOf(s.DealID) == -1) {
                salesIDS.push(s.DealID);
            }
        })
        this.props.appointmentData.forEach(a => {

            if (salesIDS.indexOf(a.DealID) != -1) {
                //find the rep here
                var rep = this.props.repData.find(r => {
                    return r.ExternalUserID == a.RepID
                });
                //the terms were agreed
                var d;
                if (!repData[a.RepID]) {
                    var tn = rep ? rep.TeamName : a.RepID;
                    var rn = rep ? rep.UserName : a.RepID;
                    d = {
                        Team: tn,
                        Name: rn,
                        Count: 1,
                        Value: a.DealValue
                    }
                } else {
                    d = repData[a.RepID];
                    d.Count = d.Count + 1;
                    d.Value = d.Value + a.DealValue;
                }
                repData[a.RepID] = d;
            }
        })
        var d = [];

        Object.keys(repData).forEach(i => {
            repData[i].Value = this.formatter.format(repData[i].Value)
            d.push(repData[i])
        })

        return d;
    }

    render() {
        const data = this.getData();
        return (
            <>
                <Table className="tablesorter" responsive>
                    <thead className="text-primary">
                    <tr>
                        <th>Team</th>
                        <th>Rep</th>
                        <th>Count</th>
                        <th className={`text-center`}>Value</th>
                    </tr>
                    </thead>
                    <tbody>
                    { data.map(d => {
                        return(

                            <tr key={d.Name}>
                                <td>{d.Team}</td>
                                <td>{d.Name}</td>
                                <td>{d.Count}</td>
                                <td className={`text-center`}>{d.Value}</td>
                            </tr>
                        )
                    })}

                    </tbody>
                </Table>
            </>
        )
    }
}

export default FollowupSoldTable;